"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSkillTag = exports.ApplicantResumeWebViewSkills = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const skillLevelMap = {
    5: 'profile.resume.skills.level.expert',
    4: 'profile.resume.skills.level.advanced',
    3: 'profile.resume.skills.level.intermediate',
    2: 'profile.resume.skills.level.elementary',
    1: 'profile.resume.skills.level.beginner',
};
const ApplicantResumeWebViewSkills = ({ skills }) => {
    const theme = (0, styled_components_1.useTheme)();
    const intl = (0, react_intl_1.useIntl)();
    const areSkillsNotRated = skills === null || skills === void 0 ? void 0 : skills.find(({ rating }) => !rating);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!areSkillsNotRated && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: skills === null || skills === void 0 ? void 0 : skills.map(skill => ((0, jsx_runtime_1.jsxs)("div", { className: "p-b-xs", children: [(0, jsx_runtime_1.jsxs)(SkillNameWrapper, { children: [skill.value, skill.rating && ((0, jsx_runtime_1.jsxs)(SkillLevelDescriptor, { children: ["(", intl.formatMessage({ id: skillLevelMap[skill.rating] }), ")"] }))] }), skill.rating && ((0, jsx_runtime_1.jsx)(elements_1.Progress, { showInfo: false, type: "line", percent: (100 / 5) * skill.rating, strokeColor: theme.color.gray8 }))] }, skill.id))) })), areSkillsNotRated && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: skills === null || skills === void 0 ? void 0 : skills.map(skill => ((0, jsx_runtime_1.jsx)(exports.CustomSkillTag, { children: skill.value }, skill.id))) }))] }));
};
exports.ApplicantResumeWebViewSkills = ApplicantResumeWebViewSkills;
const SkillNameWrapper = styled_components_1.default.div `
	display: flex;
	flex-wrap: wrap;
	gap: 0.25rem;
	font-size: ${props => props.theme.fontSizes.s};
`;
const SkillLevelDescriptor = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray6};
`;
exports.CustomSkillTag = (0, styled_components_1.default)(elements_1.Tag) `
	font-size: ${props => props.theme.fontSizes.s}
	align-items: center;
	width: fit-content;
	margin: 0.25rem;
`;
